import React, { useState } from 'react';
import './OTPModal.css'; // Styling file for the OTP modal

const OTPModal = ({ isOpen, onClose, otp, handleOTPVerification,mob }) => {
    const [enteredOtp, setEnteredOtp] = useState('');

    const handleOTPSubmit = (event) => {
        event.preventDefault();
        handleOTPVerification(enteredOtp); // Call the parent handler for OTP verification
    };

    return (
        <div className={`otp-modal ${isOpen ? 'open' : ''}`}>
           <div className="otp-modal-content" style={{ maxWidth: !mob ? '83%' : '400px' }}>
              <span className="close" onClick={onClose}>&times;</span>
                <h2 className="otp-heading">Verify OTP</h2>
                <form onSubmit={handleOTPSubmit} className="otp-form">
                    <label htmlFor="otp" className="otp-label">Please enter the code we sent to you email/phone:</label>
                    <input 
                        type="text" 
                        id="otp" 
                        className="otp-input"
                        value={enteredOtp} 
                        onChange={(e) => setEnteredOtp(e.target.value)} 
                        required 
                        placeholder=""
                        maxLength="5"
                    />
                    <button type="submit" className="otp-submit">Submit</button>
                </form>
            </div>
        </div>
    );
};

export default OTPModal;
